import { render, staticRenderFns } from "./FormularioComLocais.vue?vue&type=template&id=6dbaf604"
import script from "./FormularioComLocais.vue?vue&type=script&lang=js"
export * from "./FormularioComLocais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports